import React, { Component } from 'react';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import URLSearchParams from 'url-search-params'
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Redirect, Route, NavLink, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl'
import "assets/vendors/style"
import indigoTheme from './themes/indigoTheme';
import cyanTheme from './themes/cyanTheme';
import orangeTheme from './themes/orangeTheme';
import amberTheme from './themes/amberTheme';
import pinkTheme from './themes/pinkTheme';
import blueTheme from './themes/blueTheme';
import purpleTheme from './themes/purpleTheme';
import greenTheme from './themes/greenTheme';
import darkTheme from './themes/darkTheme';
import AppLocale from '../lngProvider';
import {
  AMBER,
  BLUE,
  CYAN,
  DARK_AMBER,
  DARK_BLUE,
  DARK_CYAN,
  DARK_DEEP_ORANGE,
  DARK_DEEP_PURPLE,
  DARK_GREEN,
  DARK_INDIGO,
  DARK_PINK,
  DEEP_ORANGE,
  DEEP_PURPLE,
  GREEN,
  INDIGO,
  PINK
} from 'constants/ThemeColors';

import MainApp from 'app/index';
import PortariaApp from 'app/portaria/index';
import SignIn from './SignIn';
import RecuperarSenha from './Recover';
import Cantina from './Cantina/Cantina';
import RestricaoAlimentar from './Cantina/RestricaoAlimentar';
import Diario from './Diario/Diario';
import { setInitUrl } from '../actions/Auth';
import RTL from 'util/RTL';
import asyncComponent from 'util/asyncComponent';
import { setDarkTheme, setThemeColor, iniciaCarregamentoRotas } from "../actions/Setting";

const RestrictedRoute = ({ component: Component, authUser, perfil, ...rest }) =>
  <Route
    {...rest}
    render={props => authUser ? <Component {...props} />
      : <Redirect
        to={{
          pathname: '/signin',
          state: { from: props.location }
        }}
      />}
  />;

class App extends Component {

  componentWillMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
    const params = new URLSearchParams(this.props.location.search);
    if (params.has("theme-name")) {
      this.props.setThemeColor(params.get('theme-name'));
    }
    if (params.has("dark-theme")) {
      this.props.setDarkTheme();
    }
  }

  getColorTheme(themeColor, applyTheme) {
    switch (themeColor) {
      case INDIGO: {
        applyTheme = createTheme(indigoTheme);
        break;
      }
      case CYAN: {
        applyTheme = createTheme(cyanTheme);
        break;
      }
      case AMBER: {
        applyTheme = createTheme(amberTheme);
        break;
      }
      case DEEP_ORANGE: {
        applyTheme = createTheme(orangeTheme);
        break;
      }
      case PINK: {
        applyTheme = createTheme(pinkTheme);
        break;
      }
      case BLUE: {
        applyTheme = createTheme(blueTheme);
        break;
      }
      case DEEP_PURPLE: {
        applyTheme = createTheme(purpleTheme);
        break;
      }
      case GREEN: {
        applyTheme = createTheme(greenTheme);
        break;
      }
      case DARK_INDIGO: {
        applyTheme = createTheme(indigoTheme);
        break;
      }
      case DARK_CYAN: {
        applyTheme = createTheme(cyanTheme);
        break;
      }
      case DARK_AMBER: {
        applyTheme = createTheme(amberTheme);
        break;
      }
      case DARK_DEEP_ORANGE: {
        applyTheme = createTheme(orangeTheme);
        break;
      }
      case DARK_PINK: {
        applyTheme = createTheme(pinkTheme);
        break;
      }
      case DARK_BLUE: {
        applyTheme = createTheme(blueTheme);
        break;
      }
      case DARK_DEEP_PURPLE: {
        applyTheme = createTheme(purpleTheme);
        break;
      }
      case DARK_GREEN: {
        applyTheme = createTheme(greenTheme);
        break;
      }
      default: createTheme(orangeTheme);
    }
    return applyTheme;
  }

  render() {
    const { match, location, isDarkTheme, locale, authUser, initURL, isDirectionRTL, invalidToken, perfil, redirecionaInicio, moduloSelecionado, configuracao } = this.props;
    let { themeColor } = this.props;
    ////let teste = this.props.iniciaCarregamentoRotas(this.props.configuracao);
    let applyTheme = createTheme(greenTheme);
    if (isDarkTheme) {
      document.body.classList.add('dark-theme');
      applyTheme = createTheme(darkTheme)
    } else {
      applyTheme = this.getColorTheme(themeColor, applyTheme);
    }
    if (location.pathname === '/') {
      if (authUser === null) {
        return (<Redirect to={'/signin'} />);
      } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
        return (<Redirect to={'/app/inicio'} />);
      } else {
        return (<Redirect to={initURL} />);
      }
    }

    if (isDirectionRTL) {
      applyTheme.direction = 'rtl';
      document.body.classList.add('rtl')
    } else {
      document.body.classList.remove('rtl');
      applyTheme.direction = 'ltr';
    }

    const currentAppLocale = AppLocale[locale.locale];
    //////const ehPortaria = this.props.ehPortaria;
    return (
      <ThemeProvider theme={applyTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}>
            <RTL>
              <div className="app-main">
                <Switch>
                  <RestrictedRoute path={`${match.url}app`} authUser={authUser} perfil={perfil}
                    component={moduloSelecionado === 'Portaria' ? PortariaApp : MainApp} />
                  <Route path='/signin' component={SignIn} />
                  <Route path='/recover-password/:token' component={RecuperarSenha} />
                  <Route path='/cantina' component={Cantina} />
                  <Route path='/restricao-alimentar' component={RestricaoAlimentar} />
                  <Route path='/diario-escolar' component={Diario} />
                  <Route
                    component={asyncComponent(() => import('app/routes/extraPages/routes/404'))} />
                </Switch>
              </div>
            </RTL>
          </IntlProvider>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { themeColor, sideNavColor, darkTheme, locale, isDirectionRTL, redirecionaInicio, moduloSelecionado, configuracao } = settings;
  const { authUser, initURL, perfil } = auth;
  return { themeColor, sideNavColor, isDarkTheme: darkTheme, locale, isDirectionRTL, authUser, perfil, initURL, redirecionaInicio, moduloSelecionado, configuracao }
};

export default connect(mapStateToProps, { setInitUrl, setThemeColor, setDarkTheme, iniciaCarregamentoRotas })(App);
